module.exports = __webpack_public_path__ + "img/logo_headway_blue.36cbab69.svg";